import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useRtDialogBase, registerAllRtConsultEmitters } from '@/composables/useRtDialogBase'
import { useRtTextFormat } from '@/composables/useRtTextFormat'
import RtCommonFooterText from '@/components/realtimeTransfer/RtCommonFooterText.vue'
import RtCommonOtherJobButton from '@/components/realtimeTransfer/RtCommonOtherJobButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RealtimeTransferAppealDialog',
  setup(__props) {

const text1 = ref('ダウンロードが完了しました！')
const text2 = ref('')

const base = useRtDialogBase({
  openDialogEventName: 'open-realtimetransferappeal-dialog',
  primaryConsultEventName: 'send-realtimetransferappeal-consult',
  primaryConsultHandlerKey: 'sendRealtimeTransferAppealConsult',
  defaultPermissionType: 4,
  defaultClientId: 'medley_link',
  defaultDialogName: 'medley_link-dialog',
  afterApplyInfo: ({ info }) => {
    text1.value = info.text_1 ?? 'ダウンロードが完了しました！'
    text2.value = info.text_2 ?? ''
  }
})

// RealtimeTransferCommon と同じく、各クライアントの送客 hub イベント群を一括追加 listen。
// → AppealDialog は「Medley 互換 (sendRealtimeTransferAppealConsult) + 全 RT 共通 send-*」の上位互換ハブとなる。
registerAllRtConsultEmitters(base)

const dialogInfo = base.dialogInfo

const { formattedText: formattedText1 } = useRtTextFormat({
  text: text1,
  dialogInfo,
  spMaxCharsKey: 'text_1_sp_max_chars',
  pcMaxCharsKey: 'text_1_pc_max_chars'
})
const { formattedText: formattedText2 } = useRtTextFormat({
  text: text2,
  dialogInfo,
  spMaxCharsKey: 'text_2_sp_max_chars',
  pcMaxCharsKey: 'text_2_pc_max_chars',
  spOnly: true
})
/** アピールポイント配列（[{ main, sub? }]） */
const appealPoints = computed<Array<{ main: string; sub?: string }>>(() => {
  const raw = dialogInfo.value.appealPoints
  return Array.isArray(raw) ? raw : []
})
/** 送信ボタン文言（既定: 「同意する」） */
const btnText = computed<string>(() => dialogInfo.value.btn_text ?? '同意する')
const showOtherJobButton = base.showOtherJobButton
const rtOtherJobButtonLabel = base.rtOtherJobButtonLabel

function onRtAppealOtherJobBtnClick () {
  base.onRtOtherJobBtnClick()
}

// CVタグ判定: true のとき送信ボタン id を {clientId}_{permissionType}_btn に切替（GTM クリックトリガー用）
const useGoogleAdsTag = base.useGoogleAdsTag
const clientId = base.clientId
const permissionType = base.permissionType

// テンプレート互換のための別名
const appealModalVisible = base.modalVisible
const isAppealSended = base.isSended
const closeAppealDialog = base.closeDialog
const onAppealModalOpened = base.onModalOpened
const onAppealModalClosed = base.onModalClosed
const handleBeforeClose = base.handleBeforeClose
const fullscreenLoading = base.fullscreenLoading
const onLogoImageLoad = base.onLogoImageLoad
const sendRealtimeTransferAppealConsult = base.sendRealtimeTransferAppealConsult

return { __sfc: true,text1, text2, base, dialogInfo, formattedText1, formattedText2, appealPoints, btnText, showOtherJobButton, rtOtherJobButtonLabel, onRtAppealOtherJobBtnClick, useGoogleAdsTag, clientId, permissionType, appealModalVisible, isAppealSended, closeAppealDialog, onAppealModalOpened, onAppealModalClosed, handleBeforeClose, fullscreenLoading, onLogoImageLoad, sendRealtimeTransferAppealConsult, RtCommonFooterText, RtCommonOtherJobButton }
}

})